export const MEETING_GAP = 10;
export const MEETING_PADDING = 16;
export const MEETING_ASPECT_RATIO = 16 / 10;

export function calculateMeetingLayout(width, height, count) {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0 ||
        !Number.isSafeInteger(count) || count <= 0) return null;

    const fit = (columns) => {
        const rows = Math.ceil(count / columns);
        const widthLimit = (width - MEETING_GAP * (columns - 1)) / columns;
        const heightLimit = (height - MEETING_GAP * (rows - 1)) / rows;
        if (widthLimit <= 0 || heightLimit <= 0) return null;
        const cardWidth = Math.min(widthLimit, heightLimit * MEETING_ASPECT_RATIO);
        const cardHeight = cardWidth / MEETING_ASPECT_RATIO;
        return { columns, rows, cardWidth, cardHeight, area: cardWidth * cardHeight };
    };

    if (count === 2 && width >= height) {
        const pair = fit(2);
        if (pair) return pair;
    }
    let best = null;
    for (let columns = 1; columns <= Math.min(count, Math.ceil(width)); columns += 1) {
        const candidate = fit(columns);
        if (candidate && (!best || candidate.area > best.area)) best = candidate;
    }
    return best;
}

export function readContentSize(element) {
    const style = element.ownerDocument.defaultView.getComputedStyle(element);
    const pixels = (value) => Number.parseFloat(value) || 0;
    return {
        width: Math.max(0, element.clientWidth - pixels(style.paddingLeft) - pixels(style.paddingRight)),
        height: Math.max(0, element.clientHeight - pixels(style.paddingTop) - pixels(style.paddingBottom)),
    };
}
